
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 113.183 113.183","height":"110","width":"110"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"#f5f5f5"}},[_c('path',{attrs:{"d":"M84.363 108.038H28.849l-7.132-74.132h69.778zm-49.573-6.54h43.633l5.872-61.051H28.92z"}}),_c('path',{attrs:{"d":"M38.93 46.986h6.543V97.13H38.93zM53.228 46.986h6.543V97.13h-6.543zM67.27 46.986h6.543V97.13H67.27zM70.764 20.407V5.145H44.599v15.262H20.615v6.541h71.952v-6.54zm-19.623 0v-8.721h13.082v8.721z"}})])])
          )
        }
      }
    